import BaseEntity from '../../base/BaseEntity.model';
import Documento from '@/models/documento.model';

export default class SolicitudEvaluacionHogarMiembroDocumento extends BaseEntity {
    public solicitudEvaluacionHogarMiembroId?: number;
    public numeroTramite?: string;
    public personaId?: number;
    public documentoId?: number;
    public documento?: Documento;
    public tipoDocumentoId?: number;
    public tipoDocumentoNombre?: string;
    constructor() {
        super();
        this.solicitudEvaluacionHogarMiembroId = undefined;
        this.numeroTramite = undefined;
        this.personaId = undefined;
        this.documentoId = undefined;
        this.documento = undefined;
        this.tipoDocumentoId = undefined;
        this.tipoDocumentoNombre = undefined;
    }
}